import React, { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";

function Landing() {
  const [LandingComponent, setLandingComponent] =
    useState<React.ComponentType | null>(null);
  const [error, setError] = useState<string | null>(null);
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    import(`./${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/index`)
      .then((module) => {
        setLandingComponent(() => module.Landing);
        setError(null); // Clear any previous errors if the component loads successfully
      })
      .catch((err) => {
        console.error("Error loading component:", err);
        setError("Failed to load the component. Please try again later.");
      });
  }, [language]);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!LandingComponent) {
    <div className="inital-loading-screen">
      <Spinner />
    </div>;
  } else {
    return <LandingComponent />;
  }
}

function LoginRegistrationLayout({ children }: { children: ReactNode }) {
  const [Component, setComponent] = useState<React.ComponentType<{
    children: ReactNode;
  }> | null>(null);

  const [error, setError] = useState<string | null>(null);
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    import(`./${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/index`)
      .then((module) => {
        setComponent(() => module.LoginRegistrationLayout);
        setError(null); // Clear any previous errors if the component loads successfully
      })
      .catch((err) => {
        console.error("Error loading component:", err);
        setError("Failed to load the component. Please try again later.");
      });
  }, [language]);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!Component) {
    <div className="inital-loading-screen">
      <Spinner />
    </div>;
  } else {
    return <Component>{children}</Component>;
  }
}

export { Landing, LoginRegistrationLayout };
